import { ProductIds } from 'core'
import { BenefitDetails as BenefitDetailsDto } from 'core/application/csiDashboard/csiSearch/getBenefitDetails'
import getProductClassDetails from 'core/application/csiDashboard/csiSearch/getProductClassDetails'
import AllowanceType from 'core/domain/benefit/allowanceType'

import ClassesSummary from 'common/components/benefit/ClassesSummary'

import { Col, Collapse, Row } from 'common/components'
import { parseZoneFormat, parseZoneMonthYearFormat } from 'common/dateFormatters'

import EarlyRunoutDetails from '../../../common/programDetails/earlyRunout'
import BenefitInfoCard from './BenefitInfoCard'

interface BenefitDetailsProps {
  translate: (key: string) => string
  benefitDetails: BenefitDetailsDto
  refreshBenefitDetails: () => Promise<void>
}

const BenefitDetails = ({ translate, benefitDetails, refreshBenefitDetails }: BenefitDetailsProps) => {
  return (
    <div>
      <div className="flex">
        <div>
          <h5 className="mr-8">{translate('csi-dashboard.program-details.benefit-details')}</h5>
        </div>
        <EarlyRunoutDetails benefitDetails={benefitDetails} refreshBenefitDetails={refreshBenefitDetails} />
      </div>
      <div className="mt-16">
        <BenefitInfoCard
          title={translate('csi-dashboard.program-details.benefit-start-date-title')}
          description={parseZoneMonthYearFormat(benefitDetails.startDate)}
          completed={true}
          translate={translate}
        />
      </div>
      <div className="mt-16">
        <BenefitInfoCard
          title={translate('csi-dashboard.program-details.benefit-end-date-title')}
          description={parseZoneFormat(benefitDetails.endDate)}
          completed={true}
          translate={translate}
        />
      </div>

      {!benefitDetails.allowToTriggeringEarlyRunout && (
        <div className="mt-16">
          <BenefitInfoCard
            title={translate('csi-dashboard.program-details.trigger-early-runout.early-run-out-days')}
            description={benefitDetails.runOutDays}
            completed={true}
            translate={translate}
          />
        </div>
      )}
      <div className="mt-8">
        <BenefitInfoCard
          title={translate('csi-dashboard.program-details.number-of-classes')}
          description={
            benefitDetails.sameClassForAll
              ? translate('csi-dashboard.program-details.single')
              : translate('csi-dashboard.program-details.multiple')
          }
          completed={true}
          translate={translate}
        />
      </div>
      <div className="mt-8">
        <BenefitInfoCard
          title={translate('csi-dashboard.program-details.allowance-type-title')}
          description={
            benefitDetails.allowanceType === AllowanceType.Annual
              ? translate('csi-dashboard.program-details.allowance-full-type')
              : translate('csi-dashboard.program-details.allowance-monthly-type')
          }
          completed={true}
          translate={translate}
        />
      </div>
      <div className="mt-8">
        <BenefitInfoCard
          title={translate('csi-dashboard.program-details.restrict-reimbursement-categories-title')}
          description={
            benefitDetails.restrictedExpenseCategories.length
              ? benefitDetails.restrictedExpenseCategories.map((c) => c.name).join(',')
              : 'N/A'
          }
          completed={true}
          translate={translate}
        />
      </div>
      <div className="mt-16">
        <Collapse
          defaultActiveKey={['1']}
          panels={[
            {
              key: benefitDetails.productClasses.length === 1 ? 1 : 0,
              content: (
                <ClassesSummary
                  classes={benefitDetails.productClasses}
                  sameClassForAll={benefitDetails.sameClassForAll}
                  apiEndpoint={getProductClassDetails}
                  productId={ProductIds.GroupHraId}
                />
              ),
              header: (
                <Row className="header_content">
                  <Col span={24} className="collapse_content">
                    <h5 className="design_classes_title">
                      {translate('admin-dashboard.benefit-details.summary.class-design-title')}
                    </h5>
                    <h5>{benefitDetails.productClasses.map((item: any) => item.name).join(', ')}</h5>
                  </Col>
                </Row>
              ),
              className: 'design_classes_collapse',
            },
          ]}
        />
      </div>
    </div>
  )
}

export default BenefitDetails
